/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import RelationshipBaseRequestHandler from './RelationshipBaseRequestHandler';
import { applyTransforms, findDirectLink, formatLinkStrength } from 'components/startingPoints/relationshipGraph/RelationshipUtil.js';

/**
 *
 * This class handles show relationship request
 *
 * @extends RelationshipBaseRequestHandler
 */
class ShowRelationshipRequestHandler extends RelationshipBaseRequestHandler {
	/**
	 * @Overriden RelationshipBaseRequestHandler._sendRequest
	 */
	static _sendRequest(querySpec, requestOptions, context, service) {
		const lastShowRelationshipsField = context.transformOptions.lastShowRelationshipsField;
		if(lastShowRelationshipsField){
			//do a request to get data for field `from
			querySpec.targetFieldIDForExpression = lastShowRelationshipsField.from;
		}
		return super._sendRequest(querySpec, requestOptions, context, service);
	}

	static _callback(ajaxResponseData, context) {
		const lastShowRelationshipsField = context.transformOptions.lastShowRelationshipsField;
		if(lastShowRelationshipsField) {
			const result = findDirectLink(lastShowRelationshipsField.from, lastShowRelationshipsField.to, ajaxResponseData);
			if(result) {
				lastShowRelationshipsField.relationship = {
					toNode: result.nodeTwo,
					link: formatLinkStrength(result.link)
				};
			}
		}
	}

	/**
	 * @Overriden RelationshipBaseRequestHandler._handleResponse
	 */
	static _handleResponse(querySpec, ajaxResponse, context, service){
		let ajaxResponseData = ajaxResponse.data;
		if (service._isSucessfulResponse(ajaxResponseData)) {
			service._handlePredictStatus(ajaxResponseData);
			this._callback(ajaxResponseData, context);
			ajaxResponseData = applyTransforms(context);
			return Promise.resolve(ajaxResponseData);
		} else {
			throw service._createError({
				smartsCode: ajaxResponseData.status.statusCode,
				responseMessage: ajaxResponseData.status.message
			});
		}
	}
}

export default ShowRelationshipRequestHandler;



// WEBPACK FOOTER //
// ./src/js/util/ShowRelationshipRequestHandler.js